var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 97,
    viewBox: "0 0 113 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.1789 12.5032C84.5733 8.05345 62.4895 13.5987 42.082 27.8435C21.6745 42.0883 8.84456 60.8967 8.3202 75.1994L4.97363 77.5402L11.4412 86.8092C21.182 100.764 50.694 97.0028 77.3523 78.3976C104.011 59.7924 117.735 33.3932 107.998 19.457L101.53 10.1877L98.1789 12.5032Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8798 69.1313C97.5418 50.527 111.259 24.1285 101.518 10.1685C91.777 -3.79155 62.2664 -0.0267258 35.6043 18.5776C8.94223 37.1818 -4.7749 63.5805 4.96614 77.5405C14.7072 91.5006 44.2177 87.7356 70.8798 69.1313Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1757 60.9491C86.1973 46.2806 97.6201 26.3375 90.6892 16.4047C83.7583 6.47195 61.0984 10.3109 40.0768 24.9794C19.0552 39.6478 7.63253 59.5911 14.5634 69.5239C21.4943 79.4566 44.1542 75.6175 65.1757 60.9491Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin3);
export default __webpack_public_path__ + "static/media/coin3.2b35bdab1899358fe995826f3a4b2f34.svg";
export { ForwardRef as ReactComponent };